import axios from 'axios';
function obtenerCategorias() {
  return axios.get("/obtener_categorias")
    .then((response) => {
      if (response.data) {
        return response.data;
      } else {
        throw new Error(response.data.status);
      }
    })
    .catch((error) => {
      throw error;
    });
}
function crearCategoria(categoria) {
  try {
    const response = axios.post('/crear_categoria', categoria, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response;
  } catch (error) {
    return { status: 'fail', error };
  }
}
function actualizarCategoria(categoria) {
  return axios.post("/actualizar_categoria", categoria)
    .then((response) => {
      if (response.data) {
        return response.data;
      } else {
        throw new Error(response.data.status);
      }
    })
    .catch((error) => {
      throw error;
    });
}
function estadoCategoria(categoria) {
  return axios.post("/estado_categoria", categoria)
    .then((response) => {
      if (response.data) {
        return response.data;
      } else {
        throw new Error(response.data.status);
      }
    })
    .catch((error) => {
      throw error;
    });
}
function eliminarCategoria(categoriaId) {
  return axios.post("/eliminar_categoria", { id: categoriaId })
    .then((response) => {
      if (response.data && response.data.status === "success") {
        return response.data;
      } else {
        throw new Error(response.data.message || "Error desconocido");
      }
    })
    .catch((error) => {
      console.error("Error eliminando categoria:", error);
      throw error;
    });
}
function obtenerLibros(categoriaId) {
  return axios.post("/obtener_libros", {categoriaId})
    .then((response) => {
      if (response.data) {
        return response.data;
      } else {
        throw new Error(response.data.status);
      }
    })
    .catch((error) => {
      throw error;
    });
}
function crearLibro(libro) {
  try {
    const response = axios.post('/crear_libro', libro, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response;
  } catch (error) {
    return { status: 'fail', error };
  }
}
function actualizarLibro(libro) {
  return axios.post("/actualizar_libro", libro)
    .then((response) => {
      if (response.data) {
        return response.data;
      } else {
        throw new Error(response.data.status);
      }
    })
    .catch((error) => {
      throw error;
    });
}
function estadoLibro(libro) {
  return axios.post("/estado_libro", libro)
    .then((response) => {
      if (response.data) {
        return response.data;
      } else {
        throw new Error(response.data.status);
      }
    })
    .catch((error) => {
      throw error;
    });
}
function eliminarLibro(libroId) {
  return axios.post("/eliminar_libro", { id: libroId })
    .then((response) => {
      if (response.data && response.data.status === "success") {
        return response.data;
      } else {
        throw new Error(response.data.message || "Error desconocido");
      }
    })
    .catch((error) => {
      console.error("Error eliminando libro:", error);
      throw error;
    });
}
export { obtenerCategorias, crearCategoria, actualizarCategoria, estadoCategoria, eliminarCategoria, obtenerLibros, crearLibro, actualizarLibro, estadoLibro, eliminarLibro };
